"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDateValue = exports.DEFAULT_DATE_FORMAT = exports.dateFormats = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var parse_1 = tslib_1.__importDefault(require("date-fns/parse"));
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
exports.dateFormats = [
    "MM/dd/yyyy",
    "dd/MM/yyyy",
    "dd-MM-yyyy",
    "yyyy-MM-dd",
    "M/d/yy",
    "dd.MM.yyyy",
];
exports.DEFAULT_DATE_FORMAT = "MM/dd/yyyy";
/**
 * Parses a string representation of a date of a given date format to a Date object.
 * @param value - value to parse.
 * @param dateFormat - dateFormat to assume when parsing the value.
 * @internal
 */
exports.parseDateValue = function (value, dateFormat) {
    if (dateFormat === void 0) { dateFormat = exports.DEFAULT_DATE_FORMAT; }
    if (!exports.dateFormats.includes(dateFormat)) {
        throw new sdk_backend_spi_1.UnexpectedError("Unsupported date format \"" + dateFormat + "\". Supported date formats are " + exports.dateFormats);
    }
    return parse_1.default(value, dateFormat, new Date());
};
//# sourceMappingURL=dateValueParser.js.map